import axios, { AxiosInstance, AxiosRequestConfig, Method } from "axios";
import { authHeader } from "helpers/auth-header";

export type RequestOptions = {
    method: Method,
    apiURL: string,
    data?: any,
    headers?: AxiosRequestConfig['headers']
};

const ConfigureHeaders = ( options: RequestOptions) => {

    const { method, data, headers,apiURL } = options

    var defaultHeaders: any = {
        ...authHeader()

    }


    const allHeaders = {
        ...defaultHeaders,
        ...headers
    }

    var config:AxiosRequestConfig = {
        url: apiURL,
        headers: allHeaders,

        method
    }


    

    // Agregar data solo si aplica
    if (['POST', 'PUT', 'PATCH'].includes(method.toUpperCase())) {
        config.data = data;
    }

    // Si es GET o DELETE y se pasan datos, incluirlos como params
    if (['GET', 'DELETE'].includes(method.toUpperCase()) && !!data) {
        config.params = data;
    }


    //PARA GET
    
    /*requestService('/api/users', {
        method: 'GET',
        data: { active: true } // → irá como query param: ?active=true
      });*/

    

    

    return config;
}

export default ConfigureHeaders;